import { LicenseDetails } from "../../licensing/LicenseService";
import { LicenseMessages } from "../../models/messages/Messages";

import "../../styles/licensing/tablesNotLicensed.css";

export { TablesNotLicensed };

type Props = {
  details?: LicenseDetails;
};
const TablesNotLicensed = (props: Props) => {
  if (props.details && !props.details.tables) {
    return (
      <span className={"unlicensedTablesMessage"}>
        {LicenseMessages.tablesNotLicensed()}
      </span>
    );
  }
  return null;
};
